import React, { useState } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

const GalleryP = () => {
  <style>
    {`
          .lb-canvas .lb-img {
            max-height: 100%;
          }
          .lb-img{
            width: auto
          }
        `}
  </style>;

  const images = [
    //1//

    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/2/leftjicopcqqtldjx8sb_compression.jpg",
      alt: "Photo 1",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/2/hpo9wkqhr5eq3qhozxyi_compression.jpg",
      alt: "Photo 2",
      category: "Événement",
    },

    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/2/DSCF4155_mk6jhp_compression.jpg",
      alt: "Photo 3",
      category: "Événement",
    },
    //2//
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/3/phwmvlemfxttfxwz57iv_compression.jpg",
      alt: "Photo 4",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/3/bfpt8aw9ra7tlp8de3ve_compression.jpg",
      alt: "Photo 5",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/3/c2qjsz2def8tpg095dp9_compression.jpg",
      alt: "Photo 6",
      category: "Événement",
    },
    //3//
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/5/nw2awixvjoc3ztrx2gvt_compression.jpg",
      alt: "Photo 7",
      category: "Événement",
    },

    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/5/llpuipuxbiehuxm3ahgm_compression.jpg",
      alt: "Photo 8",
      category: "Événement",
    },

    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/5/idqa1ukils8loa69dbhk_compression.jpg",
      alt: "Photo 9",
      category: "Événement",
    },
    //4//

    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/6/vnasanacnkvshvnp9kzr_compression.jpg",
      alt: "Photo 10",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/6/yhfdxu9biiqe3rdfclii_compression.jpg",
      alt: "Photo 11",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/6/u29usl7qmrl9abqpmeqa_compression.jpg",
      alt: "Photo 12",
      category: "Événement",
    },
    //5//
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/8/j11z1js2lfbfhrlgxyfv_compression.jpg",
      alt: "Photo 13",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/8/en0zcrrhcjd0ix1bcipw_compression.jpg",
      alt: "Photo 14",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/8/d7krcvmi1hjgo6bvp949_compression.jpg",
      alt: "Photo 15",
      category: "Événement",
    },
    //6//
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/9/fkhpatfv7qnguts5hkam_compression.jpg",
      alt: "Photo 16",
      category: "Événement",
    },

    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/9/dvbhocehpvnwyajumn0d_compression.jpg",
      alt: "Photo 17",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/9/z0h63vljxnieakn1vcih_compression.jpg",
      alt: "Photo 18",
      category: "Événement",
    },
    //6//
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/10/tjxov9mxstgmceerfmxk_compression.jpg",
      alt: "Photo 19",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/bjauwnwhcuhjajkldvpq_compression.jpg",
      alt: "Photo 20",
      category: "Événement",
    },

    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/10/cnbcaqc6cswxftvey6jp_compression.jpg",
      alt: "Photo 21",
      category: "Événement",
    },

    //7//
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/4/qmk4xxins6u4zeumowb3_compression.jpg",
      alt: "Photo 22",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/4/shw7decshhminkghgjyw_compression.jpg",
      alt: "Photo 23",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/4/stnitxgczetl9uk0m4ri_compression.jpg",
      alt: "Photo 24",
      category: "Événement",
    },
    //8//

    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/fudy6vltvu4lniyupi6g_compression.jpg",
      alt: "Photo 25",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/13/kr4j2f9t10z6wd8jjfel_compression.jpg",
      alt: "Photo 26",
      category: "Événement",
    },
    {
      src: "/img/portfolio/evenementiel/NEW-EVENT/13/jcbgwdgbe0vmsof0qvp7_compression.jpg",
      alt: "Photo 27",
      category: "Événement",
    },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  return (
    <>
      {/* Section Header */}
      <section
        className="banner-header banner-img banner-img-top section-padding valign bg-img bg-fixed banner-overlay"
        data-overlay-darkgray="1"
        style={{
          backgroundImage:
            "url('/img/portfolio/evenementiel/NEW-EVENT/3/bfpt8aw9ra7tlp8de3ve_compression.jpg')",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <h1>Evenementiel</h1>
              <hr className="border-1 text-white" />
              <p>
                Immortalisez l’énergie de vos événements grâce à des
                photographies qui capturent des moments uniques et de partage.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section Portfolio */}
      <section className="projects2 section-padding bg-blck">
        <div className="container">
          <div className="row">
            {images.map((image, index) => (
              <div
                key={index}
                className="col-12 col-md-4 portfolio-masonry-wrapper-padding"
              >
                <div className="portfolio-item-wrapp">
                  <div
                    className="portfolio-item"
                    onClick={() => {
                      setPhotoIndex(index);
                      setIsOpen(true);
                    }}
                  >
                    <div className="portfolio-masonry-wrapper">
                      <img
                        src={image.src}
                        className="img-fluid mx-auto d-block"
                        alt={image.alt}
                      />
                      <div className="portfolio-masonry-item-content">
                        <div className="portfolio-masonry-item-category">
                          {image.category}
                        </div>
                        <h4 className="portfolio-masonry-item-title">
                          {image.title}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Lightbox */}
        {isOpen && (
          <Lightbox
            images={images.map((img) => ({ url: img.src, title: img.title }))}
            startIndex={photoIndex}
            onClose={() => setIsOpen(false)}
          />
        )}
      </section>
    </>
  );
};

export default GalleryP;
